import { useEffect, useState } from 'react';
import { ORDER_TYPE, PAYMENT_GATEWAY } from '../../constants';
import Price from '../price';
import { IOrder, IProductCharacter } from '../../type';
import Tag from '../tag';
import StandalonePaymentCloseOverlay from './standalone-close-overlay';

const AUTO_CLOSE_MS = 3000;

export function renderGateway(paymentGateway: string) {
  switch (paymentGateway) {
    // case PAYMENT_GATEWAY.GOOGLE_IAP:
    //   return <Tag color="#eb4a3d">GG IAP</Tag>;
    // case PAYMENT_GATEWAY.APPLE_IAP:
    //   return <Tag color="#080808">Apple IAP</Tag>;
    case PAYMENT_GATEWAY.MOMO:
      return <Tag color="#a80f69">MoMo</Tag>;
    case PAYMENT_GATEWAY.ONEPAY:
      return <Tag color="#10579f">OnePay</Tag>;
    case PAYMENT_GATEWAY.PAY_OS:
      return <Tag color="#6b5aff">PayOS</Tag>;
    case PAYMENT_GATEWAY.BALANCE:
      return <Tag color="#40a7e3">{process.env.COIN_NAME || 'Joy Xu'}</Tag>;
    case PAYMENT_GATEWAY.PAYER_MAX:
      return <Tag color="blue">PayerMax</Tag>;
    case PAYMENT_GATEWAY.ZALO_PAY:
      return <Tag color="#0033c9">Zalopay</Tag>;
    default: return <Tag color="default">Không xác định</Tag>;
  }
}

export default function PaymentSuccess({
  order,
  character,
  onClose,
  standalonePayment = false,
}: {
  order: IOrder;
  character: IProductCharacter;
  onClose: Function;
  standalonePayment?: boolean;
}) {
  const [countdown, setCountdown] = useState(Math.ceil(AUTO_CLOSE_MS / 1000));
  const isGiftCode = order?.type === ORDER_TYPE.GIFT_CODE;

  useEffect(() => {
    // Standalone dùng overlay riêng; gift code không auto đóng
    if (standalonePayment || isGiftCode) return undefined;

    const tick = window.setInterval(() => {
      setCountdown((prev) => Math.max(0, prev - 1));
    }, 1000);
    const closeTimer = window.setTimeout(() => {
      onClose();
    }, AUTO_CLOSE_MS);

    return () => {
      window.clearInterval(tick);
      window.clearTimeout(closeTimer);
    };
    // Chỉ chạy 1 lần khi hiện success — tránh reset khi poll cập nhật order
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {standalonePayment && <StandalonePaymentCloseOverlay refId={order?.id} />}
    <div className={"payment_box"}>
      <div className={"payment_container"}>
        <h1>Giao dịch thành công</h1>
        <p>Bạn đã hoàn thành giao dịch với thông tin chi tiết</p>
        {!standalonePayment && !isGiftCode && (
          <p style={{ color: '#666', fontSize: 13, marginTop: -4 }}>
            Popup sẽ tự đóng sau {countdown}s
          </p>
        )}
        <div className={"info_box"}>
          {order?.serverId && order?.charId && (
            <>
              <div className={"info_item"}>
                <div className={"label"}>Máy chủ</div>
                <div className={"value"}>{order?.serverName || character?.serverName}</div>
              </div>
              <div className={"info_item"}>
                <div className={"label"}>Nhân vật</div>
                <div className={"value"}>{order?.charName || character.charName}</div>
              </div>
            </>
          )}
          {/* <div className={info_item}>
              <div className={label}>Gói nạp</div>
              <div className={value}>{order?.packageName || order?.ticketName}</div>
            </div> */}
          <div className={"info_item"}>
            <div className={"label"}>Mệnh giá</div>
            {order?.type === ORDER_TYPE.TICKET && order?.paymentGateway === PAYMENT_GATEWAY.BALANCE ? (
              <div className={"value"} style={{ display: 'inline-flex', alignItems: 'center' }}>
                {order?.topUpAmount * -1}
                <img src={process.env.COIN_URL || 'https://image.joyplay.vn/joy/iconjoy.png'} height={18} width={20} style={{ width: 'auto', marginLeft: '5px' }} alt="joy-xu" />
              </div>
            ) : (
              <div className={"value"}><Price amount={order?.amount} currency={order?.currency} /></div>
            )}
          </div>
          {(order?.type === ORDER_TYPE.TOP_UP || (order?.type === ORDER_TYPE.TICKET && order?.paymentGateway === PAYMENT_GATEWAY.BALANCE)) && (
            <>
              <div className={"info_item"}>
                <div className={"label"}>
                  {order?.type === ORDER_TYPE.TOP_UP ? 'Số xu trước khi nạp' : 'Số xu ban đầu'}
                </div>
                <div className={"value"}>
                  <Price amount={order?.beginningBalance} />
                </div>
              </div>
              <div className={"info_item"}>
                <div className={"label"}>
                  {order?.type === ORDER_TYPE.TOP_UP ? 'Số xu sau khi nạp' : 'Số xu còn lại'}
                </div>
                <div className={"value"}>
                  <Price amount={order?.endingBalance} />
                </div>
              </div>
            </>
          )}
          {order?.type === ORDER_TYPE.GIFT_CODE && order?.giftCode && (
            <div className={"info_item"}>
              <div className={"label"}>Mã code</div>
              <div className={"value"}>{order.giftCode}</div>
            </div>
          )}
          <div className={"info_item"}>
            <div className={"label"}>Hình thức</div>
            <div className={"value"}>{renderGateway(order?.paymentGateway || order?.metadata?.paymentGateway)}</div>
          </div>
        </div>
        {!standalonePayment && (
          <div className="text-center" style={{ margin: '10px 0' }}>
            <button
              type="button"
              className='primary_btn'
              onClick={() => {
                if (isGiftCode) {
                  window.location.href = `/game/${order.productId}?tab=gift-codes`;
                } else {
                  onClose();
                }
              }}
            >
              {isGiftCode
                ? 'Tiếp tục mua gift code'
                : `Thoát${countdown > 0 ? ` (${countdown}s)` : ''}`}
            </button>
          </div>
        )}
      </div>
    </div>
    </>
  );
}
